import React from 'react';
import { useJourneyContext } from 'Contexts';
import { Icons } from 'Assets';
import { Loader } from 'Components';
import clsx from 'clsx';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: ButtonVariant;
  withLoader?: boolean;
  size?: 'large' | 'regular' | 'icon';
}

const classNamesByVariant: Record<ButtonVariant, string> = {
  brand:
    'bg-red text-white border-red hover:bg-interface-red-hovered hover:border-interface-red-hovered active:bg-interface-red-pressed active:border-interface-red-pressed',
  'c&c-button':
    'bg-nero text-white border-nero hover:bg-interface-nero-hovered hover:border-interface-nero-hovered active:bg-interface-nero-pressed active:border-interface-nero-pressed',
  primary:
    'bg-navy-blue text-white border-navy-blue hover:bg-interface-blue-hovered hover:border-interface-blue-hovered active:bg-interface-blue-pressed active:border-interface-blue-pressed',
  secondary: 'bg-transparent text-navy-blue border-navy-blue hover:bg-interface-white-hovered active:bg-interface-white-pressed',
  tertiary:
    'bg-whitesmoke text-navy-blue border-whitesmoke hover:bg-interface-white-hovered hover:border-interface-white-hovered active:bg-interface-white-pressed active:border-interface-white-pressed',
  'tertiary-bg-none':
    'bg-transparent text-navy-blue border-transparent disabled:bg-transparent disabled:border-transparent hover:bg-interface-white-hovered hover:border-interface-white-hovered active:bg-interface-white-pressed active:border-interface-white-pressed',
};

export const Button: React.FC<Props> = ({
  children,
  variant = 'tertiary',
  withLoader = false,
  className = '',
  size = 'regular',
  ...rest
}) => {
  const { loading } = useJourneyContext();

  const classNamesBySize: Record<string, string> = {
    large: 'h-12 px-6 text-base',
    regular: 'h-10 px-4 text-sm',
    icon: 'size-10',
  };

  return (
    <button
      className={clsx(
        'cursor-pointer disabled:cursor-not-allowed disabled:bg-silver-medal disabled:border-silver-medal disabled:text-sonic-silver text-nowrap font-semibold rounded-full border',
        className,
        classNamesBySize[size ?? 'regular'],
        classNamesByVariant[variant],
        size !== 'icon' && 'md:min-w-[120px] md:w-auto w-full',
      )}
      {...rest}
    >
      {withLoader && loading ? <Loader key="loading" icon={Icons.SpinnerWhite} /> : children}
    </button>
  );
};
